<div class="add-problem-modal">
  <div class="modal-header">
    <h6 class="modal-title">Add Problem</h6>
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body">
    <form
      [formGroup]="addProplemForm"
      (ngSubmit)="onAddProplemSubmit()"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="form-control-label" for="problem-description">
              Problem Description
            </label>
            <input
              type="text"
              id="problem-description"
              class="form-control"
              formControlName="proplemDescription"
            />
            <div
              *ngIf="
                (isSubmited ||
                  addProplemForm.controls.proplemDescription.dirty) &&
                addProplemForm.controls.proplemDescription.errors
              "
              class="input-errors"
            >
              <p
                *ngIf="
                  addProplemForm.controls.proplemDescription.errors
                    .required
                "
              >
                This field is required!
              </p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <button
            class="btn btn-block btn-primary"
            type="submit"
            [disabled]="addProplemForm.invalid"
          >
            Add Problem
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
